import LegalDocumentPage from '../components/legal-page/LegalDocumentPage';

export default function TermsPage() {
  return <LegalDocumentPage pageKey="terms" />;
}
